// Global
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { useTheme } from 'lib/context/ThemeContext';
import { Placeholder, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

// Components
import { BlogContainerTheme } from './BlogContainer.theme';
import classNames from 'classnames';
import Component from 'src/helpers/Component/Component';

export type BlogContainerProps =
  Feature.EnterpriseWeb.Enterprise.Components.Tabs.BlogContainer.BlogContainer;

const BlogContainer = (props: BlogContainerProps): JSX.Element => {
  const { themeData } = useTheme(BlogContainerTheme);
  return (
    <Component dataComponent="tabs/blogcontainer" {...props}>
      <Placeholder
        name="components"
        rendering={props.rendering}
        render={(childComponents) => {
          return childComponents.map((component, index) => (
            <div key={index} className={classNames(themeData.classes.contentWrapper)}>
              {component}
            </div>
          ));
        }}
      />
    </Component>
  );
};

export default withDatasourceCheck()<BlogContainerProps>(BlogContainer);
